<template>
<w-sliding-popup :type="slidingPopupType" ref="slidingPopup" :title="popupTitle" width="500px" @open="open" @close="onClose" append-to-body modal-append-to-body>
  <div slot="content">
    <el-form :model="eventAlarmRuleFormData" label-position="top" :rules="rules" ref="eventAlarmRuleForm" class="event-alarm-rule-form">
      <el-row class="mr-b25">
        <div class="title-h4 title-bar">이벤트 설정</div>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="자원구분명" prop="rsctypeName">
              <el-input v-model="eventAlarmRuleFormData.rsctypeName" placeholder="입력해 주세요." disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="자원명" prop="rscName">
              <el-input v-model="eventAlarmRuleFormData.rscName" placeholder="입력해 주세요." disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="판단순위" prop="eventJudgePriority">
              <el-input v-model="eventAlarmRuleFormData.eventJudgePriority" placeholder="입력해 주세요." disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="16">
            <el-form-item label="이벤트 등급" prop="eventlevelId">
              <el-select v-model="eventAlarmRuleFormData.eventlevelId" style="width:100%" :disabled="eventId == 'NORMAL' || !hasAuth">
                <el-option v-for="item in eventlevelInfo" :key="item.eventlevelId" :label="item.eventlevelName" :value="item.eventlevelId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="적용" prop="applyFlag">
              <el-switch v-model="eventAlarmRuleFormData.applyFlag" active-value="Y" inactive-value="N" style="height:28px" :disabled="eventId == 'NORMAL' || !hasAuth"></el-switch>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="isTargetEventCondition != true">
          <el-form-item v-if="eventId != 'NORMAL'" class="event-critical-point-legend" prop="eventCondition" :rules="{
            required: true,
            message: '필수 정보입니다.',
            trigger: 'blur',
          }">
            <div slot="label" style="display:inline-block; width:97%;">
              <div style="width: 100%; display:flex; justify-content: space-between; align-items: center; margin-bottom: 4px;">
                <span>이벤트 판단조건</span>
                <el-popover placement="left" width="500" trigger="click">
                  <div class="title-bar title-h4">동적 임계치 범례</div>
                  <el-table-wrapper ref="eventLegendTable" :data="tableData" :columns="columnsData" :column-default="columnDefault"
                  :pagination="false" max-height="400" fixed>
                  </el-table-wrapper>
                  <el-button slot="reference" size="mini">범례</el-button>
                </el-popover>
              </div>
            </div>
            <el-input :disabled="!hasAuth" v-model="eventAlarmRuleFormData.eventCondition" placeholder="입력해 주세요."></el-input>
          </el-form-item>
          <el-form-item v-if="eventId == 'NORMAL'" label="이벤트 판단조건" prop="eventCondition">
            <el-input v-model="eventAlarmRuleFormData.eventCondition" placeholder="입력해 주세요." :disabled="eventId == 'NORMAL'"></el-input>
          </el-form-item>
        </el-row>
        <el-row v-else>
          <el-form-item v-if="eventId != 'NORMAL'" class="event-critical-point-legend" prop="staticEventCondition" :rules="{ trigger: 'blur', validator: this.validateStaticEventCondition }">
            <div slot="label" style="display:inline-block; width:100%;">
              <div style="width: 100%; display:flex; justify-content: space-between; align-items: center; margin-bottom: 4px;">
                <span>
                   고정 이벤트 판단조건
                   <el-switch v-model="staticFlag" style="height:28px" :disabled="!hasAuth"></el-switch>
                </span>
                <span>
                  <el-popover placement="left" width="500" trigger="click">
                    <div class="title-bar title-h4">동적 임계치 범례</div>
                    <el-table-wrapper ref="eventLegendTable" :data="tableData" :columns="columnsData" :column-default="columnDefault"
                    :pagination="false" max-height="400" fixed>
                    </el-table-wrapper>
                    <el-button slot="reference" size="mini">범례</el-button>
                  </el-popover>
                </span>
              </div>
            </div>
            <el-input :disabled="!isStaticFlag" v-model="eventAlarmRuleFormData.staticEventCondition" placeholder="입력해 주세요."></el-input>
          </el-form-item>
          <el-form-item v-if="eventId != 'NORMAL'" label="동적 이벤트 판단조건" prop="dynamicEventCondition" :rules="{ trigger: 'blur', validator: this.validateEventCondition }">
            <span slot="label">
               동적 이벤트 판단조건
               <el-switch v-model="dynamicFlag" style="height:28px" @change="dynamicFlagChange" :disabled="!hasAuth"></el-switch>
            </span>
            <el-row :gutter="10">
              <el-col :span="12">
                <el-checkbox :disabled="!isDynamicFlag" v-model="upThresholdFlag" @change="upThresholdChange">예측값 +</el-checkbox>
                <el-input-number :disabled="!isDynamicFlag || !upThresholdFlag" class="mr-l5" style="width:42%;" v-model="upThresholdValue" controls-position="right" :min="1" :max="100"></el-input-number>
                <span class="mr-l4">% 이상</span>
              </el-col>
              <el-col :span="12">
                <el-checkbox :disabled="!isDynamicFlag" v-model="downThresholdFlag" @change="downThresholdChange">예측값 -</el-checkbox>
                <el-input-number :disabled="!isDynamicFlag || !downThresholdFlag" class="mr-l5" style="width:42%;" v-model="downThresholdValue" controls-position="right" :min="1" :max="100"></el-input-number>
                <span class="mr-l4">% 이하</span>
              </el-col>
            </el-row>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="이벤트 메시지" prop="eventMessage">
            <el-input v-model="eventAlarmRuleFormData.eventMessage" placeholder="입력해 주세요." disabled></el-input>
          </el-form-item>
        </el-row>
      </el-row>
      <el-row>
        <div class="title-h4 title-bar">알람 설정</div>
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="문자" prop="smsFlag">
              <el-switch v-model="eventAlarmRuleFormData.smsFlag" active-value="Y" inactive-value="N" style="height:28px"></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="이메일" prop="emailFlag">
              <el-switch v-model="eventAlarmRuleFormData.emailFlag" active-value="Y" inactive-value="N" style="height:28px"></el-switch>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="알람 순차전송 템플릿" prop="alarmRepeatId">
              <el-select v-model="eventAlarmRuleFormData.alarmRepeatId" style="width:100%" :disabled="disabledAlarmRepeat">
                <el-option v-for="item in ruleMgrAlarmRepeatList" :key="item.alarmRepeatId" :label="item.alarmRepeatName" :value="item.alarmRepeatId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-row>
    </el-form>
  </div>
  <div slot="footer">
    <el-button size="large" type="solid" style="margin-right: 5px;" @click="saveButton">저장</el-button>
    <el-button size="large" @click="close">취소</el-button>
  </div>
</w-sliding-popup>
</template>

<script>
import { mapGetters } from 'vuex';
import { cloneDeep, isNil, isEmpty } from 'lodash';
import msgUtil from '@/utils/message';
import EventAlarmRuleSettingsAPI from '@/api/settings/common/event-alarm-rule-settings';
import { columnDefault } from '@/constants/table';
import { eventCriticalPointLegend } from '@/constants/event';

export default {
  name: 'WUpdateEventAlarmRulePopup',
  props: {
    /**
     * 변경 대상 이벤트/알람 설정 데이터
     */
    targetEventAlarmData: {
      type: Object,
    },
    /**
     * 슬라이딩 팝업 타입
     */
    slidingPopupType: {
      type: String,
    },
    /**
     * 이벤트/알람 개별 설정 여부
     * true: 개별 설정 / false: 정책 설정
     */
    individual: {
      type: Boolean,
      default: false,
    },
    /**
     * 예측 대상 자원으로 선택된 항목만 보일것인지 여부
     */
    isOnlyPredictRscList: {
      type: Boolean,
      default: false,
    },
    /**
     * 사용자 계정 알람 설정 플래그 - 사용자는 알람관련만 설정할 수 있도록 분기
     */
    hasAuth: {
      type: Boolean,
      default: () => false,
    },
  },
  computed: {
    /**
     * 알람 설정(문자 or 이메일) 플래그 변경시 순차발송 템플릿 활성화
     * @return {[type]} [description]
     * @author jda
     */
    disabledAlarmRepeat() {
      const formData = this.eventAlarmRuleFormData;
      return formData.smsFlag === 'N' && formData.emailFlag === 'N';
    },
    isTargetEventCondition() {
      return ((!isNil(this.targetEventAlarmData) && (this.targetEventAlarmData.predictTargetFlag === 'Y')) || this.isOnlyPredictRscList);
    },
    isStaticFlag() {
      return (this.staticFlag && this.hasAuth);
    },
    isDynamicFlag() {
      return (this.dynamicFlag && this.hasAuth);
    },
    ...mapGetters(['eventlevelInfo']),
  },
  watch: {
    targetEventAlarmData(object) {
      if (!isNil(object)) {
        this.eventId = object.eventId;
        this.staticFlag = (object.staticApplyFlag === 'Y');
        this.dynamicFlag = (object.dynamicApplyFlag === 'Y');
        if (this.dynamicFlag) {
          this.settingDynamicValues(object.dynamicEventCondition);
        }
      }
    },
  },
  data() {
    return {
      upThresholdValue: 0,
      downThresholdValue: 0,
      upThresholdFlag: false,
      downThresholdFlag: false,
      staticFlag: false,
      dynamicFlag: false,
      popupTitle: null,
      ruleMgrAlarmRepeatList: [],
      eventId: null,
      eventAlarmRuleFormData: {
        staticEventCondition: null,
        eventlevelId: null,
        alarmRepeatId: null,
        applyFlag: null,
        smsFlag: null,
        emailFlag: null,
        eventCondition: null,
      },
      rules: {
        eventlevelId: {
          required: true,
          message: '필수 정보입니다.',
          trigger: 'blur',
        },
      },
      tableData: eventCriticalPointLegend,
      showSearchTool: false,
      columnDefault,
      columnsData: [
        {
          prop: 'value',
          label: '정규식',
          headerAlign: 'center',
          sortable: true,
        },
        {
          prop: 'desc',
          label: '설명',
          headerAlign: 'center',
          sortable: true,
        },
      ],
    };
  },
  methods: {
    open() {
      this.popupTitle = `[${this.targetEventAlarmData.rscName}] 이벤트/알람 정보`;
      Object.assign(this.eventAlarmRuleFormData, this.targetEventAlarmData);
      EventAlarmRuleSettingsAPI.getRuleMgrAlarmRepeatList().then((response) => {
        const result = response.data.data;
        if (!isNil(result)) {
          const tempList = cloneDeep(result);
          const firstObject = {
            alarmRepeatId: null,
            alarmRepeatName: '선택 안함',
          };
          tempList.unshift(firstObject);
          this.ruleMgrAlarmRepeatList = tempList;
        }
      });
    },
    onClose() {
      this.upThresholdValue = 0;
      this.downThresholdValue = 0;
      this.upThresholdFlag = false;
      this.downThresholdFlag = false;
      this.$refs.eventAlarmRuleForm.resetFields();
    },
    saveButton() {
      const eventAlarmRuleFormData = this.eventAlarmRuleFormData;
      const target = '이벤트/알람 정책';
      const action = msgUtil.action.SAVE;
      this.$refs.eventAlarmRuleForm.validate((response) => {
        if (response) {
          if (!this.individual) {
            EventAlarmRuleSettingsAPI.updateEventAlarmRuleInfo(eventAlarmRuleFormData).then((res) => {
              if (res.data.success) {
                this.$message(msgUtil.getResultMsgData(action, target, true));
                this.$emit('reload');
                this.close();
              } else {
                this.$message(msgUtil.getResultMsgData(action, target, false));
              }
            }).catch((e) => {
              this.$message(msgUtil.getResultMsgData(action, target, false));
              throw new Error(e);
            });
          } else {
            const params = this.eventAlarmRuleFormData;
            if (this.dynamicFlag === true) {
              // 동적 이벤트 판단 조건을 만드는 함수 호출
              params.dynamicApplyFlag = 'Y';
              params.dynamicEventCondition = this.getDynamicEventCondition();
              // 동적 + 정적
              if (this.staticFlag === true) {
                params.staticApplyFlag = 'Y';
                params.eventCondition = `${params.staticEventCondition} || (${params.dynamicEventCondition})`;
              } else {
                // 동적 이벤트 판단 조건만 설정되어 있는 경우
                params.staticApplyFlag = 'N';
                params.staticEventCondition = null;
                params.eventCondition = params.dynamicEventCondition;
              }
            } else {
              params.dynamicApplyFlag = 'N';
              params.dynamicEventCondition = null;
              // 정적 이벤트 판단 조건만 설정되어 있는 경우
              if (this.staticFlag === true && this.isTargetEventCondition === false) {
                params.staticApplyFlag = 'Y';
                params.staticEventCondition = params.eventCondition;
              } else if (this.staticFlag === true && this.isTargetEventCondition === true) {
                params.staticApplyFlag = 'Y';
                params.eventCondition = params.staticEventCondition;
              }
            }
            if (this.isTargetEventCondition === true && this.individual === true) {
              // 동적/ 정적 판단 조건 모두가 설정되어 있지 않는 경우
              if (this.dynamicFlag === false && this.staticFlag === false) {
                this.$message(msgUtil.getCustomMsgData('이벤트 판단 조건을 설정해주십시오.'));
              } else {
                EventAlarmRuleSettingsAPI.updatePredictEventInfo(params).then((res) => {
                  if (res.data.success) {
                    this.$message(msgUtil.getResultMsgData(action, target, true));
                    this.$emit('reload');
                    this.close();
                  } else {
                    this.$message(msgUtil.getResultMsgData(action, target, false));
                  }
                }).catch((e) => {
                  this.$message(msgUtil.getResultMsgData(action, target, false));
                  throw new Error(e);
                });
              }
            } else {
              EventAlarmRuleSettingsAPI.updateIndividualEventAlarmRuleInfo(params).then((res) => {
                if (res.data.success) {
                  this.$message(msgUtil.getResultMsgData(action, target, true));
                  this.$emit('reload');
                  this.close();
                } else {
                  this.$message(msgUtil.getResultMsgData(action, target, false));
                }
              }).catch((e) => {
                this.$message(msgUtil.getResultMsgData(action, target, false));
                throw new Error(e);
              });
            }
          }
        } else {
          this.$message(msgUtil.getCustomMsgData('이벤트 판단 조건을 확인해주십시오.'));
        }
      });
    },
    getDynamicEventCondition() {
      let dynamicEventCondition = '';
      if (this.upThresholdFlag && this.downThresholdFlag) {
        const upThresholdValue = ((this.upThresholdValue / 100) + 1.0);
        const downThresholdValue = (1.0 - (this.downThresholdValue / 100));
        dynamicEventCondition = `$VALUE$ >= $PREDICT$ * ${upThresholdValue} || $VALUE$ <= $PREDICT$ * ${downThresholdValue}`;
      } else if (this.upThresholdFlag && !this.downThresholdFlag) {
        const upThresholdValue = ((this.upThresholdValue / 100) + 1.0);
        dynamicEventCondition = `$VALUE$ >= $PREDICT$ * ${upThresholdValue}`;
      } else if (!this.upThresholdFlag && this.downThresholdFlag) {
        const downThresholdValue = (1.0 - (this.downThresholdValue / 100));
        dynamicEventCondition = `$VALUE$ <= $PREDICT$ * ${downThresholdValue}`;
      }
      return dynamicEventCondition;
    },
    close() {
      this.upThresholdValue = 0;
      this.downThresholdValue = 0;
      this.upThresholdFlag = false;
      this.downThresholdFlag = false;
      this.$refs.eventAlarmRuleForm.resetFields();
      this.$refs.slidingPopup.visible = false;
    },
    /**
     * 동적 이벤트 판단 조건 플래그가 false인 경우에는 validation 검증을 수행하지 않도록 한다.
     * @author yelim
     */
    dynamicFlagChange() {
      if (this.dynamicFlag === false && this.upThresholdValue === 0 && this.downThresholdValue === 0) {
        this.upThresholdFlag = false;
        this.downThresholdFlag = false;
        this.$refs.eventAlarmRuleForm.clearValidate();
      } else if (this.upThresholdValue === 0 && this.downThresholdValue === 0) {
        this.upThresholdFlag = true;
      }
    },
    /**
     * 동적 이벤트 판단 조건 > 예측값 이상 체크박스 change 이벤트
     * @author yelim
     */
    upThresholdChange() {
      this.$refs.eventAlarmRuleForm.validateField('dynamicEventCondition');
    },
    /**
     * 동적 이벤트 판단 조건 > 예측값 이하 체크박스 change 이벤트
     * @author yelim
     */
    downThresholdChange() {
      this.$refs.eventAlarmRuleForm.validateField('dynamicEventCondition');
    },
    /**
     * 동적 이벤트 판단 조건의 유효성 검사
     * @author yelim
     */
    validateEventCondition(rule, value, callback) {
      // 1. 각각 이상 or 이하 체크박스가 설정되어 있는데 값이 존재하지 않는 경우
      // 2. 동적 이벤트 판단 조건이 true로 설정되어 있는데 이상 && 이하 체크박스가 선택되지 않은 경우
      if ((isNil(this.upThresholdValue) && this.upThresholdFlag === true) || (isNil(this.downThresholdValue) && this.downThresholdFlag === true)) {
        callback(new Error('필수 정보입니다.'));
      } else if (this.dynamicFlag === true && this.upThresholdFlag === false && this.downThresholdFlag === false) {
        callback(new Error('필수 정보입니다.'));
      } else {
        callback();
      }
    },
    validateStaticEventCondition(rule, value, callback) {
      if (isEmpty(value) && this.staticFlag === true) {
        callback(new Error('필수 정보입니다.'));
      } else {
        callback();
      }
    },
    settingDynamicValues(condition) {
      const splitExpression = condition.split('||');
      splitExpression.forEach((item) => {
        const expressionValue = item.split('*');
        if (expressionValue[0].includes('>=')) {
          const upThres = (expressionValue[1].trim() - 1) * 100;
          this.upThresholdFlag = true;
          this.upThresholdValue = upThres.toFixed();
        } else {
          const downThres = (1 - expressionValue[1].trim()) * 100;
          this.downThresholdFlag = true;
          this.downThresholdValue = downThres.toFixed();
        }
      });
    },
    onSearchToolButtonClick() {
      this.showSearchTool = !this.showSearchTool;
    },
  },
};
</script>

<style>
.event-alarm-rule-form .event-critical-point-legend .el-form-item__label {
  width: 100%;
  padding: 0px;
}
</style>



// WEBPACK FOOTER //
// src/views/settings/operation/BasicInfoSettings/EventAlarmRuleSettings/popup/UpdateEventAlarmRulePopup.vue